import { Inject, Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { StateService } from '@uirouter/core';
import { EMPTY, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { IXMOptions } from 'core/interfaces';
import { CONFIG_TOKEN } from 'core/constants';
import { LoggerService } from './logger';

@Injectable()
export class CmsErrorInterceptor implements HttpInterceptor {
    private config: IXMOptions;
    private state: StateService;
    private logger: LoggerService;

    constructor(state: StateService, @Inject(CONFIG_TOKEN) config: IXMOptions, logger: LoggerService) {
        Object.assign(this, { state, config, logger });
    }

    public intercept(request: HttpRequest<object>, next: HttpHandler): Observable<HttpEvent<object>> {
        let newRequest: HttpRequest<object> = request;
        const startTime: number = performance.now();

        const handleCmsError: boolean = request.headers.has('handleCmsError');
        newRequest = newRequest.clone({ headers: request.headers.delete('handleCmsError') });

        return next.handle(newRequest).pipe(
            catchError((error: HttpErrorResponse) => {
                if (!handleCmsError && error?.url?.includes(this.config.URL_CMS)) {
                    this.logger.error(error, newRequest, startTime);
                    this.state.go('downtime');

                    return EMPTY;
                }

                return throwError(error);
            })
        );
    }
}
